/*! lazysizes - v5.3.2 */ !(function (t, e) {
  var i = function () {
    e(t.lazySizes), t.removeEventListener("lazyunveilread", i, !0);
  };
  (e = e.bind(null, t, t.document)),
    "object" == typeof module && module.exports
      ? e(require("lazysizes"))
      : "function" == typeof define && define.amd
      ? define(["lazysizes"], e)
      : t.lazySizes
      ? i()
      : t.addEventListener("lazyunveilread", i, !0);
})(window, function (t, e, i) {
  "use strict";
  var a,
    r,
    n = {};
  function s(t, i, a) {
    var r, s;
    n[t] ||
      ((r = e.createElement(i ? "link" : "script")),
      (s = e.getElementsByTagName("script")[0]),
      i
        ? ((r.rel = "stylesheet"), (r.href = t))
        : ((r.onload = function () {
            (r.onerror = null), (r.onload = null), a();
          }),
          (r.onerror = r.onload),
          (r.src = t)),
      (n[t] = !0),
      (n[r.src || r.href] = !0),
      s.parentNode.insertBefore(r, s));
  }
  e.addEventListener &&
    ((a = function (t, i) {
      var a = e.createElement("img");
      (a.onload = function () {
        (a.onload = null), (a.onerror = null), (a = null), i();
      }),
        (a.onerror = a.onload),
        (a.src = t),
        a && a.complete && a.onload && a.onload();
    }),
    addEventListener(
      "lazybeforeunveil",
      function (t) {
        var e, n, o;
        if (t.detail.instance == i && !t.defaultPrevented) {
          var l = t.target;
          if (
            ("none" == l.preload &&
              (l.preload = l.getAttribute("data-preload") || "auto"),
            null != l.getAttribute("data-autoplay"))
          ) {
            if (l.getAttribute("data-expand") && !l.autoplay)
              try {
                l.play();
              } catch (c) {}
            else
              requestAnimationFrame(function () {
                l.setAttribute("data-expand", "-10"), i.aC(l, i.cfg.lazyClass);
              });
          }
          (e = l.getAttribute("data-link")) && s(e, !0),
            (e = l.getAttribute("data-script")) &&
              ((t.detail.firesLoad = !0),
              s(e, null, function () {
                (t.detail.firesLoad = !1), i.fire(l, "_lazyloaded", {}, !0, !0);
              })),
            (e = l.getAttribute("data-require")) &&
              (i.cfg.requireJs ? i.cfg.requireJs([e]) : s(e)),
            (n = l.getAttribute("data-bg")) &&
              ((t.detail.firesLoad = !0),
              a(n, function () {
                (l.style.backgroundImage =
                  "url(" + (r.test(n) ? JSON.stringify(n) : n) + ")"),
                  (t.detail.firesLoad = !1),
                  i.fire(l, "_lazyloaded", {}, !0, !0);
              })),
            (o = l.getAttribute("data-poster")) &&
              ((t.detail.firesLoad = !0),
              a(o, function () {
                (l.poster = o),
                  (t.detail.firesLoad = !1),
                  i.fire(l, "_lazyloaded", {}, !0, !0);
              }));
        }
      },
      ((r = /\(|\)|\s|'/), !1)
    ));
}),
  (function (t, e) {
    var i = function (a) {
      e(t.lazySizes, a), t.removeEventListener("lazyunveilread", i, !0);
    };
    (e = e.bind(null, t, t.document)),
      "object" == typeof module && module.exports
        ? e(require("lazysizes"))
        : t.lazySizes
        ? i()
        : t.addEventListener("lazyunveilread", i, !0);
  })(window, function (t, e, i, a) {
    "use strict";
    var r = e.createElement("a").style,
      n = "objectFit" in r,
      s = /object-fit["']*\s*:\s*["']*(contain|cover)/,
      o = /object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/,
      l =
        "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
      c = /\(|\)|'/,
      u = { center: "center", "50% 50%": "center" };
    if (!n || !(n && "objectPosition" in r)) {
      var d = function (t) {
        if (t.detail.instance == i) {
          var e,
            a,
            r,
            d,
            f,
            p,
            y,
            z,
            g,
            v,
            m,
            b,
            A,
            h = t.target,
            $ =
              ((e = h),
              (d =
                ((r =
                  (a =
                    (getComputedStyle(e, null) || {}).fontFamily || "").match(
                    s
                  ) || "") &&
                  a.match(o)) ||
                "") && (d = d[1]),
              { fit: (r && r[1]) || "", position: u[d] || d || "center" });
          !$.fit ||
            (n && "center" == $.position) ||
            ((f = h),
            (p = $),
            (g = i.cfg),
            (m = (v = f.cloneNode(!1)).style),
            (b = function () {
              var t = f.currentSrc || f.src;
              t &&
                z !== t &&
                ((z = t),
                (m.backgroundImage =
                  "url(" + (c.test(t) ? JSON.stringify(t) : t) + ")"),
                y ||
                  ((y = !0), i.rC(v, g.loadingClass), i.aC(v, g.loadedClass)));
            }),
            (A = function () {
              i.rAF(b);
            }),
            (f._lazysizesParentFit = p.fit),
            f.addEventListener("lazyloaded", A, !0),
            f.addEventListener("load", A, !0),
            v.addEventListener("load", function () {
              var t = v.currentSrc || v.src;
              t && t != l && ((v.src = l), (v.srcset = ""));
            }),
            i.rAF(function () {
              var t = f,
                e = f.parentNode;
              "PICTURE" == e.nodeName.toUpperCase() &&
                ((t = e), (e = e.parentNode)),
                i.rC(v, g.loadedClass),
                i.rC(v, g.lazyClass),
                i.aC(v, g.loadingClass),
                i.aC(v, g.objectFitClass || "lazysizes-display-clone"),
                v.getAttribute(g.srcsetAttr) &&
                  v.setAttribute(g.srcsetAttr, ""),
                v.getAttribute(g.srcAttr) && v.setAttribute(g.srcAttr, ""),
                (v.src = l),
                (v.srcset = ""),
                (m.backgroundRepeat = "no-repeat"),
                (m.backgroundPosition = p.position),
                (m.backgroundSize = p.fit),
                (t.style.display = "none"),
                f.setAttribute("data-parent-fit", p.fit),
                f.setAttribute("data-parent-container", "prev"),
                e.insertBefore(v, t),
                f._lazysizesParentFit && delete f._lazysizesParentFit,
                f.complete && b();
            }));
        }
      };
      t.addEventListener("lazyunveilread", d, !0), a && a.detail && d(a);
    }
  }),
  (function (t, e) {
    var i = function () {
      e(t.lazySizes), t.removeEventListener("lazyunveilread", i, !0);
    };
    (e = e.bind(null, t, t.document)),
      "object" == typeof module && module.exports
        ? e(require("lazysizes"))
        : t.lazySizes
        ? i()
        : t.addEventListener("lazyunveilread", i, !0);
  })(window, function (t, e, i) {
    "use strict";
    function a(t, i, a) {
      var r,
        o,
        l,
        c,
        u = 0,
        d = 0,
        f = a;
      if (t) {
        if ("container" === i.ratio) {
          for (u = f.scrollWidth, d = f.scrollHeight; !((u && d) || f === e); )
            (u = (f = f.parentNode).scrollWidth), (d = f.scrollHeight);
          u && d && (i.ratio = d / u);
        }
        ((t =
          ((r = t),
          (o = i),
          (l = []),
          (c = function (t, e) {
            return p[typeof o[e]] ? o[e] : t;
          }),
          (l.srcset = []),
          o.absUrl && (h.setAttribute("href", r), (r = h.href)),
          (r = ((o.prefix || "") + r + (o.postfix || "")).replace(m, c)),
          o.widths.forEach(function (t) {
            var e = o.widthmap[t] || t,
              i = o.aspectratio || o.ratio,
              a = !o.aspectratio && s.traditionalRatio,
              n = {
                u: r
                  .replace(g, e)
                  .replace(
                    v,
                    i ? (a ? Math.round(t * i) : Math.round(t / i)) : ""
                  ),
                w: t,
              };
            l.push(n), l.srcset.push((n.c = n.u + " " + t + "w"));
          }),
          l)).isPicture = i.isPicture),
          E && "IMG" == a.nodeName.toUpperCase()
            ? a.removeAttribute(n.srcsetAttr)
            : a.setAttribute(n.srcsetAttr, t.srcset.join(", ")),
          Object.defineProperty(a, "_lazyrias", { value: t, writable: !0 });
      }
    }
    function r(t) {
      return (
        t.getAttribute(t.getAttribute("data-srcattr") || s.srcAttr) ||
        t.getAttribute(n.srcsetAttr) ||
        t.getAttribute(n.srcAttr) ||
        t.getAttribute("data-pfsrcset") ||
        ""
      );
    }
    var n,
      s,
      o,
      l,
      c,
      u,
      d,
      f,
      p = { string: 1, number: 1 },
      y = /^\-*\+*\d+\.*\d*$/,
      z = /^picture$/i,
      g = /\s*\{\s*width\s*\}\s*/i,
      v = /\s*\{\s*height\s*\}\s*/i,
      m = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
      b = /^\[.*\]|\{.*\}$/,
      A = /^(?:auto|\d+(px)?)$/,
      h = e.createElement("a"),
      $ = e.createElement("img"),
      E = "srcset" in $ && !("sizes" in $),
      C = !!t.HTMLPictureElement && !E;
    (function () {
      var e,
        a = {
          prefix: "",
          postfix: "",
          srcAttr: "data-src",
          absUrl: !1,
          modifyOptions: function () {},
          widthmap: {},
          ratio: !1,
          traditionalRatio: !1,
          aspectratio: !1,
        };
      for (e in ((n = (i && i.cfg) || t.lazySizesConfig) ||
        ((n = {}), (t.lazySizesConfig = n)),
      n.supportsType ||
        (n.supportsType = function (t) {
          return !t;
        }),
      n.rias || (n.rias = {}),
      "widths" in (s = n.rias) ||
        ((s.widths = []),
        (function (t) {
          for (var e, i = 0; !e || e < 3e3; )
            (i += 5) > 30 && (i += 1), (e = 36 * i), t.push(e);
        })(s.widths)),
      a))
        e in s || (s[e] = a[e]);
    })(),
      addEventListener(
        "lazybeforesizes",
        function (e) {
          if (e.detail.instance == i) {
            var o, l, c, u, d, f, p, v, h, $, E, _, N, P, L, S;
            if (
              ((o = e.target),
              e.detail.dataAttr &&
                !e.defaultPrevented &&
                !s.disabled &&
                (h = o.getAttribute(n.sizesAttr) || o.getAttribute("sizes")) &&
                A.test(h))
            ) {
              if (
                ((l = r(o)),
                (c =
                  ((P = o),
                  (S = (function e(i, a) {
                    var r,
                      n,
                      o,
                      l,
                      c = t.getComputedStyle(i);
                    for (r in ((l = {
                      isPicture: !(
                        !(n = i.parentNode) || !z.test(n.nodeName || "")
                      ),
                    }),
                    (o = function (t, e) {
                      var a = i.getAttribute("data-" + t);
                      if (!a) {
                        var r = c.getPropertyValue("--ls-" + t);
                        r && (a = r.trim());
                      }
                      if (a) {
                        if ("true" == a) a = !0;
                        else if ("false" == a) a = !1;
                        else if (y.test(a)) a = parseFloat(a);
                        else if ("function" == typeof s[t]) a = s[t](i, a);
                        else if (b.test(a))
                          try {
                            a = JSON.parse(a);
                          } catch (n) {}
                        l[t] = a;
                      } else
                        t in s && "function" != typeof s[t]
                          ? (l[t] = s[t])
                          : e &&
                            "function" == typeof s[t] &&
                            (l[t] = s[t](i, a));
                    }),
                    s))
                      o(r);
                    return (
                      a.replace(m, function (t, e) {
                        e in l || o(e, !0);
                      }),
                      l
                    );
                  })(P, (L = l))),
                  s.modifyOptions.call(P, { target: P, details: S, detail: S }),
                  i.fire(P, "lazyriasmodifyoptions", S),
                  S)),
                (E = g.test(c.prefix) || g.test(c.postfix)),
                c.isPicture && (u = o.parentNode))
              )
                for (
                  d = u.getElementsByTagName("source"), f = 0, p = d.length;
                  f < p;
                  f++
                )
                  (E || g.test((v = r(d[f])))) && (a(v, c, d[f]), (_ = !0));
              E || g.test(l)
                ? (a(l, c, o), (_ = !0))
                : _ &&
                  (((N = []).srcset = []),
                  (N.isPicture = !0),
                  Object.defineProperty(o, "_lazyrias", {
                    value: N,
                    writable: !0,
                  })),
                _ &&
                  (C
                    ? o.removeAttribute(n.srcAttr)
                    : "auto" != h &&
                      w({
                        target: o,
                        detail: ($ = { width: parseInt(h, 10) }),
                      }));
            }
          }
        },
        !0
      );
    var w =
      ((o = function (t, e) {
        return t.w - e.w;
      }),
      (l = function (t) {
        for (var e, i, a = t.length, r = t[a - 1], n = 0; n < a; n++)
          if ((((r = t[n]).d = r.w / t.w), r.d >= t.d)) {
            !r.cached &&
              (e = t[n - 1]) &&
              e.d > t.d - 0.13 * Math.pow(t.d, 2.2) &&
              ((i = Math.pow(e.d - 0.6, 1.6)),
              e.cached && (e.d += 0.15 * i),
              e.d + (r.d - t.d) * i > t.d && (r = e));
            break;
          }
        return r;
      }),
      (c = function (t, e) {
        var a;
        return (
          !t._lazyrias &&
            i.pWS &&
            (a = i.pWS(t.getAttribute(n.srcsetAttr || ""))).length &&
            (Object.defineProperty(t, "_lazyrias", { value: a, writable: !0 }),
            e &&
              t.parentNode &&
              (a.isPicture = "PICTURE" == t.parentNode.nodeName.toUpperCase())),
          t._lazyrias
        );
      }),
      (u = function (e) {
        var a = t.devicePixelRatio || 1;
        return Math.min((i.getX && i.getX(e)) || a, 2.4, a);
      }),
      (d = function (e, i) {
        var a, r, n, s, d, f;
        if ((d = e._lazyrias).isPicture && t.matchMedia) {
          for (
            r = 0, n = (a = e.parentNode.getElementsByTagName("source")).length;
            r < n;
            r++
          )
            if (
              c(a[r]) &&
              !a[r].getAttribute("type") &&
              (!(s = a[r].getAttribute("media")) ||
                (matchMedia(s) || {}).matches)
            ) {
              d = a[r]._lazyrias;
              break;
            }
        }
        return (
          (!d.w || d.w < i) && ((d.w = i), (d.d = u(e)), (f = l(d.sort(o)))), f
        );
      }),
      (f = function (a) {
        if (a.detail.instance == i) {
          var r,
            s = a.target;
          if (!E && (t.respimage || t.picturefill || lazySizesConfig.pf))
            return void e.removeEventListener("lazybeforesizes", f);
          ("_lazyrias" in s || (a.detail.dataAttr && c(s, !0))) &&
            (r = d(s, a.detail.width)) &&
            r.u &&
            s._lazyrias.cur != r.u &&
            ((s._lazyrias.cur = r.u),
            (r.cached = !0),
            i.rAF(function () {
              s.setAttribute(n.srcAttr, r.u), s.setAttribute("src", r.u);
            }));
        }
      }),
      C ? (f = function () {}) : addEventListener("lazybeforesizes", f),
      f);
  }),
  (function (t, e) {
    var i = e(t, t.document);
    (t.lazySizes = i),
      "object" == typeof module && module.exports && (module.exports = i);
  })(window, function (t, e) {
    "use strict";
    if (e.getElementsByClassName) {
      var i,
        a,
        r,
        n,
        s,
        o,
        l,
        c,
        u,
        d,
        f,
        p,
        y,
        z,
        g,
        v,
        m,
        b,
        A,
        h,
        $,
        E,
        C,
        w,
        _,
        N,
        P,
        L,
        S,
        x,
        F,
        T,
        M,
        k,
        W,
        R,
        B,
        j,
        I,
        U,
        H,
        D,
        O,
        q,
        X,
        V,
        G,
        J = e.documentElement,
        Q = t.Date,
        K = t.HTMLPictureElement,
        Y = "addEventListener",
        Z = "getAttribute",
        tt = t[Y],
        te = t.setTimeout,
        ti = t.requestAnimationFrame || te,
        ta = t.requestIdleCallback,
        tr = /^picture$/i,
        tn = ["load", "error", "lazyincluded", "_lazyloaded"],
        ts = {},
        to = Array.prototype.forEach,
        tl = function (t, e) {
          return (
            ts[e] || (ts[e] = RegExp("(\\s|^)" + e + "(\\s|$)")),
            ts[e].test(t[Z]("class") || "") && ts[e]
          );
        },
        tc = function (t, e) {
          tl(t, e) ||
            t.setAttribute("class", (t[Z]("class") || "").trim() + " " + e);
        },
        tu = function (t, e) {
          var i;
          (i = tl(t, e)) &&
            t.setAttribute("class", (t[Z]("class") || "").replace(i, " "));
        },
        td = function (t, e, i) {
          var a = i ? Y : "removeEventListener";
          i && td(t, e),
            tn.forEach(function (i) {
              t[a](i, e);
            });
        },
        tf = function (t, i, a, r, n) {
          var s = e.createEvent("Event");
          return (
            a || (a = {}),
            (a.instance = c),
            s.initEvent(i, !r, !n),
            (s.detail = a),
            t.dispatchEvent(s),
            s
          );
        },
        tp = function (e, i) {
          var a;
          !K && (a = t.picturefill || u.pf)
            ? (i && i.src && !e[Z]("srcset") && e.setAttribute("srcset", i.src),
              a({ reevaluate: !0, elements: [e] }))
            : i && i.src && (e.src = i.src);
        },
        ty = function (t, e) {
          return (getComputedStyle(t, null) || {})[e];
        },
        tz = function (t, e, i) {
          for (
            i = i || t.offsetWidth;
            i < u.minSize && e && !t._lazysizesWidth;

          )
            (i = e.offsetWidth), (e = e.parentNode);
          return i;
        },
        tg =
          ((n = []),
          (s = r = []),
          (o = function () {
            var t = s;
            for (s = r.length ? n : r, i = !0, a = !1; t.length; ) t.shift()();
            i = !1;
          }),
          ((l = function (t, r) {
            i && !r
              ? t.apply(this, arguments)
              : (s.push(t), a || ((a = !0), (e.hidden ? te : ti)(o)));
          })._lsFlush = o),
          l),
        tv = function (t, e) {
          return e
            ? function () {
                tg(t);
              }
            : function () {
                var e = this,
                  i = arguments;
                tg(function () {
                  t.apply(e, i);
                });
              };
        },
        tm = function (t) {
          var e,
            i = 0,
            a = u.throttleDelay,
            r = u.ricTimeout,
            n = function () {
              (e = !1), (i = Q.now()), t();
            },
            s =
              ta && r > 49
                ? function () {
                    ta(n, { timeout: r }),
                      r !== u.ricTimeout && (r = u.ricTimeout);
                  }
                : tv(function () {
                    te(n);
                  }, !0);
          return function (t) {
            var n;
            (t = !0 === t) && (r = 33),
              e ||
                ((e = !0),
                (n = a - (Q.now() - i)) < 0 && (n = 0),
                t || n < 9 ? s() : te(s, n));
          };
        },
        tb = function (t) {
          var e,
            i,
            a = function () {
              (e = null), t();
            },
            r = function () {
              var t = Q.now() - i;
              t < 99 ? te(r, 99 - t) : (ta || a)(a);
            };
          return function () {
            (i = Q.now()), e || (e = te(r, 99));
          };
        };
      !(function () {
        var e,
          i = {
            lazyClass: "lazyload",
            loadedClass: "lazyloaded",
            loadingClass: "lazyloading",
            preloadClass: "lazypreload",
            errorClass: "lazyerror",
            autosizesClass: "lazyautosizes",
            srcAttr: "data-src",
            srcsetAttr: "data-srcset",
            sizesAttr: "data-sizes",
            minSize: 40,
            customMedia: {},
            init: !0,
            expFactor: 1.5,
            hFac: 0.8,
            loadMode: 2,
            loadHidden: !0,
            ricTimeout: 0,
            throttleDelay: 125,
          };
        for (e in ((u = t.lazySizesConfig || t.lazysizesConfig || {}), i))
          e in u || (u[e] = i[e]);
        (t.lazySizesConfig = u),
          te(function () {
            u.init && t$();
          });
      })();
      var tA =
          ((E = /^img$/i),
          (C = /^iframe$/i),
          (w = "onscroll" in t && !/(gle|ing)bot/.test(navigator.userAgent)),
          (_ = 0),
          (N = 0),
          (P = 0),
          (L = -1),
          (S = function (t) {
            P--, (t && !(P < 0) && t.target) || (P = 0);
          }),
          (x = function (t) {
            return (
              null == $ && ($ = "hidden" == ty(e.body, "visibility")),
              $ ||
                ("hidden" != ty(t.parentNode, "visibility") &&
                  "hidden" != ty(t, "visibility"))
            );
          }),
          (F = function (t, i) {
            var a,
              r = t,
              n = x(t);
            for (
              m -= i, h += i, b -= i, A += i;
              n && (r = r.offsetParent) && r != e.body && r != J;

            )
              (n = (ty(r, "opacity") || 1) > 0) &&
                "visible" != ty(r, "overflow") &&
                (n =
                  A > (a = r.getBoundingClientRect()).left &&
                  b < a.right &&
                  h > a.top - 1 &&
                  m < a.bottom + 1);
            return n;
          }),
          (M = tm(
            (T = function () {
              var t,
                i,
                a,
                r,
                n,
                s,
                o,
                l,
                p,
                z,
                E,
                C,
                S = c.elements;
              if ((y = u.loadMode) && P < 8 && (t = S.length)) {
                for (i = 0, L++; i < t; i++)
                  if (S[i] && !S[i]._lazyRace) {
                    if (!w || (c.prematureUnveil && c.prematureUnveil(S[i])))
                      U(S[i]);
                    else if (
                      (((l = S[i][Z]("data-expand")) && (s = 1 * l)) || (s = N),
                      z ||
                        ((z =
                          !u.expand || u.expand < 1
                            ? J.clientHeight > 500 && J.clientWidth > 500
                              ? 500
                              : 370
                            : u.expand),
                        (c._defEx = z),
                        (E = z * u.expFactor),
                        (C = u.hFac),
                        ($ = null),
                        N < E && P < 1 && L > 2 && y > 2 && !e.hidden
                          ? ((N = E), (L = 0))
                          : (N = y > 1 && L > 1 && P < 6 ? z : _)),
                      p !== s &&
                        ((g = innerWidth + s * C),
                        (v = innerHeight + s),
                        (o = -1 * s),
                        (p = s)),
                      (h = (a = S[i].getBoundingClientRect()).bottom) >= o &&
                        (m = a.top) <= v &&
                        (A = a.right) >= o * C &&
                        (b = a.left) <= g &&
                        (h || A || b || m) &&
                        (u.loadHidden || x(S[i])) &&
                        ((f && P < 3 && !l && (y < 3 || L < 4)) || F(S[i], s)))
                    ) {
                      if ((U(S[i]), (n = !0), P > 9)) break;
                    } else
                      !n &&
                        f &&
                        !r &&
                        P < 4 &&
                        L < 4 &&
                        y > 2 &&
                        (d[0] || u.preloadAfterLoad) &&
                        (d[0] ||
                          (!l &&
                            (h ||
                              A ||
                              b ||
                              m ||
                              "auto" != S[i][Z](u.sizesAttr)))) &&
                        (r = d[0] || S[i]);
                  }
                r && !n && U(r);
              }
            })
          )),
          (W = tv(
            (k = function (t) {
              var e = t.target;
              if (e._lazyCache) return void delete e._lazyCache;
              S(t),
                tc(e, u.loadedClass),
                tu(e, u.loadingClass),
                td(e, R),
                tf(e, "lazyloaded");
            })
          )),
          (R = function (t) {
            W({ target: t.target });
          }),
          (B = function (t, e) {
            try {
              t.contentWindow.location.replace(e);
            } catch (i) {
              t.src = e;
            }
          }),
          (j = function (t) {
            var e,
              i = t[Z](u.srcsetAttr);
            (e = u.customMedia[t[Z]("data-media") || t[Z]("media")]) &&
              t.setAttribute("media", e),
              i && t.setAttribute("srcset", i);
          }),
          (I = tv(function (t, e, i, a, r) {
            var n, s, o, l, c, d;
            (c = tf(t, "lazybeforeunveil", e)).defaultPrevented ||
              (a && (i ? tc(t, u.autosizesClass) : t.setAttribute("sizes", a)),
              (s = t[Z](u.srcsetAttr)),
              (n = t[Z](u.srcAttr)),
              r && (l = (o = t.parentNode) && tr.test(o.nodeName || "")),
              (d = e.firesLoad || ("src" in t && (s || n || l))),
              (c = { target: t }),
              tc(t, u.loadingClass),
              d && (clearTimeout(p), (p = te(S, 2500)), td(t, R, !0)),
              l && to.call(o.getElementsByTagName("source"), j),
              s
                ? t.setAttribute("srcset", s)
                : n && !l && (C.test(t.nodeName) ? B(t, n) : (t.src = n)),
              r && (s || l) && tp(t, { src: n })),
              t._lazyRace && delete t._lazyRace,
              tu(t, u.lazyClass),
              tg(function () {
                var e = t.complete && t.naturalWidth > 1;
                (d && !e) ||
                  (e && tc(t, "ls-is-cached"),
                  k(c),
                  (t._lazyCache = !0),
                  te(function () {
                    "_lazyCache" in t && delete t._lazyCache;
                  }, 9)),
                  "lazy" == t.loading && P--;
              }, !0);
          })),
          (U = function (t) {
            if (!t._lazyRace) {
              var e,
                i = E.test(t.nodeName),
                a = i && (t[Z](u.sizesAttr) || t[Z]("sizes")),
                r = "auto" == a;
              ((!r && f) ||
                !i ||
                (!t[Z]("src") && !t.srcset) ||
                t.complete ||
                tl(t, u.errorClass) ||
                !tl(t, u.lazyClass)) &&
                ((e = tf(t, "lazyunveilread").detail),
                r && th.updateElem(t, !0, t.offsetWidth),
                (t._lazyRace = !0),
                P++,
                I(t, e, r, a, i));
            }
          }),
          (H = tb(function () {
            (u.loadMode = 3), M();
          })),
          (D = function () {
            3 == u.loadMode && (u.loadMode = 2), H();
          }),
          (O = function () {
            if (!f) {
              if (Q.now() - z < 999) return void te(O, 999);
              (f = !0), (u.loadMode = 3), M(), tt("scroll", D, !0);
            }
          }),
          {
            _: function () {
              (z = Q.now()),
                (c.elements = e.getElementsByClassName(u.lazyClass)),
                (d = e.getElementsByClassName(
                  u.lazyClass + " " + u.preloadClass
                )),
                tt("scroll", M, !0),
                tt("resize", M, !0),
                t.MutationObserver
                  ? new MutationObserver(M).observe(J, {
                      childList: !0,
                      subtree: !0,
                      attributes: !0,
                    })
                  : (J[Y]("DOMNodeInserted", M, !0),
                    J[Y]("DOMAttrModified", M, !0),
                    setInterval(M, 999)),
                tt("hashchange", M, !0),
                [
                  "focus",
                  "mouseover",
                  "click",
                  "load",
                  "transitionend",
                  "animationend",
                  "webkitAnimationEnd",
                ].forEach(function (t) {
                  e[Y](t, M, !0);
                }),
                /d$|^c/.test(e.readyState)
                  ? O()
                  : (tt("load", O), e[Y]("DOMContentLoaded", M), te(O, 2e4)),
                c.elements.length ? (T(), tg._lsFlush()) : M();
            },
            checkElems: M,
            unveil: U,
            _aLSL: D,
          }),
        th =
          ((X = tv(function (t, e, i, a) {
            var r, n, s;
            if (
              ((t._lazysizesWidth = a),
              (a += "px"),
              t.setAttribute("sizes", a),
              tr.test(e.nodeName || ""))
            )
              for (
                r = e.getElementsByTagName("source"), n = 0, s = r.length;
                n < s;
                n++
              )
                r[n].setAttribute("sizes", a);
            i.detail.dataAttr || tp(t, i.detail);
          })),
          (V = function (t, e, i) {
            var a,
              r = t.parentNode;
            r &&
              ((i = tz(t, r, i)),
              (a = tf(t, "lazybeforesizes", { width: i, dataAttr: !!e }))
                .defaultPrevented ||
                ((i = a.detail.width) &&
                  i !== t._lazysizesWidth &&
                  X(t, r, a, i)));
          }),
          {
            _: function () {
              (q = e.getElementsByClassName(u.autosizesClass)), tt("resize", G);
            },
            checkElems: (G = tb(function () {
              var t,
                e = q.length;
              if (e) for (t = 0; t < e; t++) V(q[t]);
            })),
            updateElem: V,
          }),
        t$ = function () {
          t$.i || ((t$.i = !0), th._(), tA._());
        };
      return (c = {
        cfg: u,
        autoSizer: th,
        loader: tA,
        init: t$,
        uP: tp,
        aC: tc,
        rC: tu,
        hC: tl,
        fire: tf,
        gW: tz,
        rAF: tg,
      });
    }
  }),
  (function (t, e) {
    var i = function () {
      e(t.lazySizes), t.removeEventListener("lazyunveilread", i, !0);
    };
    (e = e.bind(null, t, t.document)),
      "object" == typeof module && module.exports
        ? e(require("lazysizes"))
        : t.lazySizes
        ? i()
        : t.addEventListener("lazyunveilread", i, !0);
  })(window, function (t, e, i) {
    "use strict";
    if (t.addEventListener) {
      var a = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
        r = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
        n = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,
        s = /^picture$/i,
        o = {
          getParent: function (e, i) {
            var a = e,
              r = e.parentNode;
            return (
              (!i || "prev" == i) &&
                r &&
                s.test(r.nodeName || "") &&
                (r = r.parentNode),
              "self" != i &&
                (a =
                  "prev" == i
                    ? e.previousElementSibling
                    : (i &&
                        (r.closest || t.jQuery) &&
                        (r.closest ? r.closest(i) : jQuery(r).closest(i)[0])) ||
                      r),
              a
            );
          },
          getFit: function (t) {
            var e,
              i,
              a,
              s = ((e = t), getComputedStyle(e, null) || {}),
              l = s.content || s.fontFamily,
              c = {
                fit: t._lazysizesParentFit || t.getAttribute("data-parent-fit"),
              };
            return (
              !c.fit && l && (i = l.match(r)) && (c.fit = i[1]),
              c.fit
                ? (!(a =
                    t._lazysizesParentContainer ||
                    t.getAttribute("data-parent-container")) &&
                    l &&
                    (i = l.match(n)) &&
                    (a = i[1]),
                  (c.parent = o.getParent(t, a)))
                : (c.fit = s.objectFit),
              c
            );
          },
          getImageRatio: function (e) {
            var i,
              r,
              n,
              o,
              l,
              c,
              u,
              d = e.parentNode,
              f =
                d && s.test(d.nodeName || "")
                  ? d.querySelectorAll("source, img")
                  : [e];
            for (i = 0; i < f.length; i++)
              if (
                ((r =
                  (e = f[i]).getAttribute(lazySizesConfig.srcsetAttr) ||
                  e.getAttribute("srcset") ||
                  e.getAttribute("data-pfsrcset") ||
                  e.getAttribute("data-risrcset") ||
                  ""),
                (n = e._lsMedia || e.getAttribute("media")),
                (n =
                  lazySizesConfig.customMedia[
                    e.getAttribute("data-media") || n
                  ] || n),
                r && (!n || ((t.matchMedia && matchMedia(n)) || {}).matches))
              ) {
                (o = parseFloat(e.getAttribute("data-aspectratio"))) ||
                  ((l = r.match(a))
                    ? "w" == l[2]
                      ? ((c = l[1]), (u = l[3]))
                      : ((c = l[3]), (u = l[1]))
                    : ((c = e.getAttribute("width")),
                      (u = e.getAttribute("height"))),
                  (o = c / u));
                break;
              }
            return o;
          },
          calculateSize: function (t, e) {
            var i,
              a,
              r,
              n,
              s = this.getFit(t),
              o = s.fit,
              l = s.parent;
            return "width" == o ||
              (("contain" == o || "cover" == o) && (r = this.getImageRatio(t)))
              ? (l ? (e = l.clientWidth) : (l = t),
                (n = e),
                "width" == o
                  ? (n = e)
                  : (a = l.clientHeight) > 40 &&
                    (i = e / a) &&
                    (("cover" == o && i < r) || ("contain" == o && i > r)) &&
                    (n = e * (r / i)),
                n)
              : e;
          },
        };
      (i.parentFit = o),
        e.addEventListener("lazybeforesizes", function (t) {
          if (!t.defaultPrevented && t.detail.instance == i) {
            var e = t.target;
            t.detail.width = o.calculateSize(e, t.detail.width);
          }
        });
    }
  }),
  (function (t, e) {
    var i = function () {
      e(t.lazySizes), t.removeEventListener("lazyunveilread", i, !0);
    };
    (e = e.bind(null, t, t.document)),
      "object" == typeof module && module.exports
        ? e(require("lazysizes"))
        : t.lazySizes
        ? i()
        : t.addEventListener("lazyunveilread", i, !0);
  })(window, function (t, e, i) {
    "use strict";
    var a,
      r,
      n,
      s,
      o,
      l,
      c,
      u,
      d,
      f,
      p,
      y,
      z,
      g,
      v,
      m,
      b,
      A,
      h = i && i.cfg,
      $ = e.createElement("img"),
      E = "sizes" in $ && "srcset" in $,
      C = /\s+\d+h/g,
      w =
        ((m = /\s+(\d+)(w|h)\s+(\d+)(w|h)/),
        (b = Array.prototype.forEach),
        function () {
          var t = e.createElement("img"),
            a = function (t) {
              var e,
                i,
                a = t.getAttribute(lazySizesConfig.srcsetAttr);
              a &&
                (i = a.match(m)) &&
                ((e = "w" == i[2] ? i[1] / i[3] : i[3] / i[1]) &&
                  t.setAttribute("data-aspectratio", e),
                t.setAttribute(lazySizesConfig.srcsetAttr, a.replace(C, "")));
            },
            r = function (t) {
              if (t.detail.instance == i) {
                var e = t.target.parentNode;
                e &&
                  "PICTURE" == e.nodeName &&
                  b.call(e.getElementsByTagName("source"), a),
                  a(t.target);
              }
            },
            n = function () {
              t.currentSrc && e.removeEventListener("lazybeforeunveil", r);
            };
          e.addEventListener("lazybeforeunveil", r),
            (t.onload = n),
            (t.onerror = n),
            (t.srcset = "data:,a 1w 1h"),
            t.complete && n();
        });
    if (
      (h.supportsType ||
        (h.supportsType = function (t) {
          return !t;
        }),
      t.HTMLPictureElement && E)
    )
      return void (
        !i.hasHDescriptorFix &&
        e.msElementsFromPoint &&
        ((i.hasHDescriptorFix = !0), w())
      );
    t.picturefill ||
      h.pf ||
      ((h.pf = function (e) {
        var i, a;
        if (!t.picturefill)
          for (i = 0, a = e.elements.length; i < a; i++) A(e.elements[i]);
      }),
      (A =
        ((o = function (t, e) {
          return t.w - e.w;
        }),
        (l = /^\s*\d+\.*\d*px\s*$/),
        (c = function (t) {
          for (var e, i, a = t.length, r = t[a - 1], n = 0; n < a; n++)
            if ((((r = t[n]).d = r.w / t.w), r.d >= t.d)) {
              !r.cached &&
                (e = t[n - 1]) &&
                e.d > t.d - 0.13 * Math.pow(t.d, 2.2) &&
                ((i = Math.pow(e.d - 0.6, 1.6)),
                e.cached && (e.d += 0.15 * i),
                e.d + (r.d - t.d) * i > t.d && (r = e));
              break;
            }
          return r;
        }),
        (u =
          ((r = /(([^,\s].[^\s]+)\s+(\d+)w)/g),
          (n = /\s/),
          (s = function (t, e, i, r) {
            a.push({ c: e, u: i, w: 1 * r });
          }),
          function (t) {
            return (
              (a = []),
              (t = t.trim()).replace(C, "").replace(r, s),
              a.length || !t || n.test(t) || a.push({ c: t, u: t, w: 99 }),
              a
            );
          })),
        (d = function () {
          var t, i, a;
          d.init ||
            ((d.init = !0),
            addEventListener(
              "resize",
              ((i = e.getElementsByClassName("lazymatchmedia")),
              (a = function () {
                var t, e;
                for (t = 0, e = i.length; t < e; t++) A(i[t]);
              }),
              function () {
                clearTimeout(t), (t = setTimeout(a, 66));
              })
            ));
        }),
        (f = function (e, a) {
          var r,
            n = e.getAttribute("srcset") || e.getAttribute(h.srcsetAttr);
          !n &&
            a &&
            (n = e._lazypolyfill
              ? e._lazypolyfill._set
              : e.getAttribute(h.srcAttr) || e.getAttribute("src")),
            (e._lazypolyfill && e._lazypolyfill._set == n) ||
              ((r = u(n || "")),
              a &&
                e.parentNode &&
                ((r.isPicture =
                  "PICTURE" == e.parentNode.nodeName.toUpperCase()),
                r.isPicture &&
                  t.matchMedia &&
                  (i.aC(e, "lazymatchmedia"), d())),
              (r._set = n),
              Object.defineProperty(e, "_lazypolyfill", {
                value: r,
                writable: !0,
              }));
        }),
        (p = function (e) {
          var a = t.devicePixelRatio || 1;
          return Math.min((i.getX && i.getX(e)) || a, 2.5, a);
        }),
        (y = function (e) {
          return t.matchMedia
            ? (y = function (t) {
                return !t || (matchMedia(t) || {}).matches;
              })(e)
            : !e;
        }),
        (z = function (t) {
          var e, a, r, n, s, u, d;
          if ((f((n = t), !0), (s = n._lazypolyfill).isPicture)) {
            for (
              a = 0,
                r = (e = t.parentNode.getElementsByTagName("source")).length;
              a < r;
              a++
            )
              if (
                h.supportsType(e[a].getAttribute("type"), t) &&
                y(e[a].getAttribute("media"))
              ) {
                f((n = e[a])), (s = n._lazypolyfill);
                break;
              }
          }
          return (
            s.length > 1
              ? ((d = n.getAttribute("sizes") || ""),
                (d = (l.test(d) && parseInt(d, 10)) || i.gW(t, t.parentNode)),
                (s.d = p(t)),
                s.src && s.w && !(s.w < d)
                  ? (u = s.src)
                  : ((s.w = d), (u = c(s.sort(o))), (s.src = u)))
              : (u = s[0]),
            u
          );
        }),
        ((g = function (t) {
          if (
            !E ||
            !t.parentNode ||
            "PICTURE" == t.parentNode.nodeName.toUpperCase()
          ) {
            var e = z(t);
            e &&
              e.u &&
              t._lazypolyfill.cur != e.u &&
              ((t._lazypolyfill.cur = e.u),
              (e.cached = !0),
              t.setAttribute(h.srcAttr, e.u),
              t.setAttribute("src", e.u));
          }
        }).parse = u),
        g)),
      h.loadedClass &&
        h.loadingClass &&
        ((v = []),
        ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(
          function (t) {
            v.push(t + h.loadedClass), v.push(t + h.loadingClass);
          }
        ),
        h.pf({ elements: e.querySelectorAll(v.join(", ")) })));
  }),
  (function (t, e) {
    var i = function () {
      e(t.lazySizes), t.removeEventListener("lazyunveilread", i, !0);
    };
    (e = e.bind(null, t, t.document)),
      "object" == typeof module && module.exports
        ? e(require("lazysizes"))
        : t.lazySizes
        ? i()
        : t.addEventListener("lazyunveilread", i, !0);
  })(window, function (t, e, i) {
    "use strict";
    if (t.addEventListener) {
      var a = /\s+/g,
        r = /\s*\|\s+|\s+\|\s*/g,
        n = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/,
        s = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/,
        o = /\(|\)|'/,
        l = { contain: 1, cover: 1 },
        c = function (t) {
          var e = i.gW(t, t.parentNode);
          return (
            (!t._lazysizesWidth || e > t._lazysizesWidth) &&
              (t._lazysizesWidth = e),
            t._lazysizesWidth
          );
        },
        u = function (t) {
          var e;
          return (
            !l[
              (e = (
                getComputedStyle(t) || { getPropertyValue: function () {} }
              ).getPropertyValue("background-size"))
            ] &&
              l[t.style.backgroundSize] &&
              (e = t.style.backgroundSize),
            e
          );
        },
        d = function (t, e) {
          if (e) {
            var i = e.match(s);
            i && i[1]
              ? t.setAttribute("type", i[1])
              : t.setAttribute("media", lazySizesConfig.customMedia[e] || e);
          }
        },
        f = function (t, i, s) {
          var o = e.createElement("picture"),
            l = i.getAttribute(lazySizesConfig.sizesAttr),
            c = i.getAttribute("data-ratio"),
            u = i.getAttribute("data-optimumx");
          i._lazybgset &&
            i._lazybgset.parentNode == i &&
            i.removeChild(i._lazybgset),
            Object.defineProperty(s, "_lazybgset", { value: i, writable: !0 }),
            Object.defineProperty(i, "_lazybgset", { value: o, writable: !0 }),
            (t = t.replace(a, " ").split(r)),
            (o.style.display = "none"),
            (s.className = lazySizesConfig.lazyClass),
            1 != t.length || l || (l = "auto"),
            t.forEach(function (t) {
              var i,
                a = e.createElement("source");
              l && "auto" != l && a.setAttribute("sizes", l),
                (i = t.match(n))
                  ? (a.setAttribute(lazySizesConfig.srcsetAttr, i[1]),
                    d(a, i[2]),
                    d(a, i[3]))
                  : a.setAttribute(lazySizesConfig.srcsetAttr, t),
                o.appendChild(a);
            }),
            l &&
              (s.setAttribute(lazySizesConfig.sizesAttr, l),
              i.removeAttribute(lazySizesConfig.sizesAttr),
              i.removeAttribute("sizes")),
            u && s.setAttribute("data-optimumx", u),
            c && s.setAttribute("data-ratio", c),
            o.appendChild(s),
            i.appendChild(o);
        },
        p = function (t) {
          if (t.target._lazybgset) {
            var e = t.target,
              a = e._lazybgset,
              r = e.currentSrc || e.src;
            if (r) {
              var n = i.fire(a, "bgsetproxy", {
                src: r,
                useSrc: o.test(r) ? JSON.stringify(r) : r,
              });
              n.defaultPrevented ||
                (a.style.backgroundImage = "url(" + n.detail.useSrc + ")");
            }
            e._lazybgsetLoading &&
              (i.fire(a, "_lazyloaded", {}, !1, !0),
              delete e._lazybgsetLoading);
          }
        };
      addEventListener("lazybeforeunveil", function (t) {
        var a, r, n;
        !t.defaultPrevented &&
          (a = t.target.getAttribute("data-bgset")) &&
          ((n = t.target),
          ((r = e.createElement("img")).alt = ""),
          (r._lazybgsetLoading = !0),
          (t.detail.firesLoad = !0),
          f(a, n, r),
          setTimeout(function () {
            i.loader.unveil(r),
              i.rAF(function () {
                i.fire(r, "_lazyloaded", {}, !0, !0),
                  r.complete && p({ target: r });
              });
          }));
      }),
        e.addEventListener("load", p, !0),
        t.addEventListener(
          "lazybeforesizes",
          function (t) {
            if (
              t.detail.instance == i &&
              t.target._lazybgset &&
              t.detail.dataAttr
            ) {
              var e = u(t.target._lazybgset);
              l[e] &&
                ((t.target._lazysizesParentFit = e),
                i.rAF(function () {
                  t.target.setAttribute("data-parent-fit", e),
                    t.target._lazysizesParentFit &&
                      delete t.target._lazysizesParentFit;
                }));
            }
          },
          !0
        ),
        e.documentElement.addEventListener("lazybeforesizes", function (t) {
          !t.defaultPrevented &&
            t.target._lazybgset &&
            t.detail.instance == i &&
            (t.detail.width = c(t.target._lazybgset));
        });
    }
  });

/*! parent-fit */
!(function (t, e) {
  var i;
  t &&
    ((i = function () {
      e(t.lazySizes), t.removeEventListener("lazyunveilread", i, !0);
    }),
    (e = e.bind(null, t, t.document)),
    "object" == typeof module && module.exports
      ? e(require("lazysizes"))
      : "function" == typeof define && define.amd
      ? define(["lazysizes"], e)
      : t.lazySizes
      ? i()
      : t.addEventListener("lazyunveilread", i, !0));
})("undefined" != typeof window ? window : 0, function (u, t, i) {
  "use strict";
  var l, s, d, f, g, o;
  u.addEventListener &&
    ((l = /\s+(\d+)(w|h)\s+(\d+)(w|h)/),
    (s = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/),
    (d = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/),
    (f = /^picture$/i),
    (g = i.cfg),
    (o = {
      getParent: function (t, e) {
        var i = t,
          a = t.parentNode;
        return (
          (e && "prev" != e) ||
            !a ||
            !f.test(a.nodeName || "") ||
            (a = a.parentNode),
          "self" != e &&
            (i =
              "prev" == e
                ? t.previousElementSibling
                : (e &&
                    (a.closest || u.jQuery) &&
                    (a.closest ? a.closest(e) : jQuery(a).closest(e)[0])) ||
                  a),
          i
        );
      },
      getFit: function (t) {
        var e,
          i,
          a = getComputedStyle(t, null) || {},
          n = a.content || a.fontFamily,
          r = {
            fit: t._lazysizesParentFit || t.getAttribute("data-parent-fit"),
          };
        return (
          !r.fit && n && (e = n.match(s)) && (r.fit = e[1]),
          r.fit
            ? (!(i =
                t._lazysizesParentContainer ||
                t.getAttribute("data-parent-container")) &&
                n &&
                (e = n.match(d)) &&
                (i = e[1]),
              (r.parent = o.getParent(t, i)))
            : (r.fit = a.objectFit),
          r
        );
      },
      getImageRatio: function (t) {
        for (
          var e,
            i,
            a,
            n,
            r,
            s,
            d = t.parentNode,
            o =
              d && f.test(d.nodeName || "")
                ? d.querySelectorAll("source, img")
                : [t],
            c = 0;
          c < o.length;
          c++
        )
          if (
            ((e =
              (t = o[c]).getAttribute(g.srcsetAttr) ||
              t.getAttribute("srcset") ||
              t.getAttribute("data-pfsrcset") ||
              t.getAttribute("data-risrcset") ||
              ""),
            (i = t._lsMedia || t.getAttribute("media")),
            (i = g.customMedia[t.getAttribute("data-media") || i] || i),
            e && (!i || ((u.matchMedia && matchMedia(i)) || {}).matches))
          ) {
            (a = parseFloat(t.getAttribute("data-aspectratio"))) ||
              ((s = (n = e.match(l))
                ? "w" == n[2]
                  ? ((r = n[1]), n[3])
                  : ((r = n[3]), n[1])
                : ((r = t.getAttribute("width")), t.getAttribute("height"))),
              (a = r / s));
            break;
          }
        return a;
      },
      calculateSize: function (t, e) {
        var i,
          a,
          n,
          r = this.getFit(t),
          s = r.fit,
          d = r.parent;
        return "width" == s ||
          (("contain" == s || "cover" == s) && (a = this.getImageRatio(t)))
          ? (d ? (e = d.clientWidth) : (d = t),
            (n = e),
            "width" == s
              ? (n = e)
              : (i = e / d.clientHeight) &&
                (("cover" == s && i < a) || ("contain" == s && a < i)) &&
                (n = e * (a / i)),
            n)
          : e;
      },
    }),
    (i.parentFit = o),
    t.addEventListener("lazybeforesizes", function (t) {
      var e;
      t.defaultPrevented ||
        t.detail.instance != i ||
        ((e = t.target), (t.detail.width = o.calculateSize(e, t.detail.width)));
    }));
});
/*! object-fit */
!(function (e, i) {
  var a;
  e &&
    ((a = function (t) {
      i(e.lazySizes, t), e.removeEventListener("lazyunveilread", a, !0);
    }),
    (i = i.bind(null, e, e.document)),
    "object" == typeof module && module.exports
      ? i(require("lazysizes"))
      : "function" == typeof define && define.amd
      ? define(["lazysizes"], i)
      : e.lazySizes
      ? a()
      : e.addEventListener("lazyunveilread", a, !0));
})("undefined" != typeof window ? window : 0, function (t, u, f, e) {
  "use strict";
  var y,
    i,
    a = u.createElement("a").style,
    r = "objectFit" in a,
    s = /object-fit["']*\s*:\s*["']*(contain|cover)/,
    l = /object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/,
    A =
      "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
    n = /\(|\)|'/,
    d = { center: "center", "50% 50%": "center" };
  function c(o, r) {
    function s() {
      var t = o.currentSrc || o.src;
      t &&
        i !== t &&
        ((i = t),
        (d.backgroundImage =
          "url(" + (n.test(t) ? JSON.stringify(t) : t) + ")"),
        e || ((e = !0), f.rC(l, c.loadingClass), f.aC(l, c.loadedClass)));
    }
    function t() {
      f.rAF(s);
    }
    var e,
      i,
      l,
      d,
      c = f.cfg;
    (o._lazysizesParentFit = r.fit),
      o.addEventListener("lazyloaded", t, !0),
      o.addEventListener("load", t, !0),
      f.rAF(function () {
        var t,
          e,
          i,
          a = o,
          n = o.parentNode;
        "PICTURE" == n.nodeName.toUpperCase() && (n = (a = n).parentNode),
          (e = (t = a).previousElementSibling) &&
            f.hC(e, y) &&
            (e.parentNode.removeChild(e),
            (t.style.position = e.getAttribute("data-position") || ""),
            (t.style.visibility = e.getAttribute("data-visibility") || "")),
          y ||
            y ||
            ((i = u.createElement("style")),
            (y = f.cfg.objectFitClass || "lazysizes-display-clone"),
            u.querySelector("head").appendChild(i)),
          (l = o.cloneNode(!1)),
          (d = l.style),
          l.addEventListener("load", function () {
            var t = l.currentSrc || l.src;
            t && t != A && ((l.src = A), (l.srcset = ""));
          }),
          f.rC(l, c.loadedClass),
          f.rC(l, c.lazyClass),
          f.rC(l, c.autosizesClass),
          f.aC(l, c.loadingClass),
          f.aC(l, y),
          [
            "data-parent-fit",
            "data-parent-container",
            "data-object-fit-polyfilled",
            c.srcsetAttr,
            c.srcAttr,
          ].forEach(function (t) {
            l.removeAttribute(t);
          }),
          (l.src = A),
          (l.srcset = ""),
          (d.backgroundRepeat = "no-repeat"),
          (d.backgroundPosition = r.position),
          (d.backgroundSize = r.fit),
          l.setAttribute("data-position", a.style.position),
          l.setAttribute("data-visibility", a.style.visibility),
          (a.style.visibility = "hidden"),
          (a.style.position = "absolute"),
          o.setAttribute("data-parent-fit", r.fit),
          o.setAttribute("data-parent-container", "prev"),
          o.setAttribute("data-object-fit-polyfilled", ""),
          (o._objectFitPolyfilledDisplay = l),
          n.insertBefore(l, a),
          o._lazysizesParentFit && delete o._lazysizesParentFit,
          o.complete && s();
      });
  }
  (r && r && "objectPosition" in a) ||
    ((i = function (t) {
      if (t.detail.instance == f) {
        var e,
          i,
          a,
          n = t.target,
          o =
            ((e = (getComputedStyle(n, null) || {}).fontFamily || ""),
            (i = e.match(s) || ""),
            (a = (a = (i && e.match(l)) || "") && a[1]),
            { fit: (i && i[1]) || "", position: d[a] || a || "center" });
        return !(!o.fit || (r && "center" == o.position)) && (c(n, o), !0);
      }
    }),
    t.addEventListener("lazybeforesizes", function (t) {
      var e;
      t.detail.instance == f &&
        (null == (e = t.target).getAttribute("data-object-fit-polyfilled") ||
          e._objectFitPolyfilledDisplay ||
          i(t) ||
          f.rAF(function () {
            e.removeAttribute("data-object-fit-polyfilled");
          }));
    }),
    t.addEventListener("lazyunveilread", i, !0),
    e && e.detail && i(e));
});
/*! respimg */
!(function (e, t) {
  var r;
  e &&
    ((r = function () {
      t(e.lazySizes), e.removeEventListener("lazyunveilread", r, !0);
    }),
    (t = t.bind(null, e, e.document)),
    "object" == typeof module && module.exports
      ? t(require("lazysizes"))
      : "function" == typeof define && define.amd
      ? define(["lazysizes"], t)
      : e.lazySizes
      ? r()
      : e.addEventListener("lazyunveilread", r, !0));
})("undefined" != typeof window ? window : 0, function (d, n, p) {
  "use strict";
  var i,
    a,
    s,
    l,
    t,
    r,
    f,
    o,
    c,
    m,
    u,
    y = p.cfg,
    e = n.createElement("img"),
    g = "sizes" in e && "srcset" in e,
    h = /\s+\d+h/g,
    z =
      ((a = /\s+(\d+)(w|h)\s+(\d+)(w|h)/),
      (s = Array.prototype.forEach),
      function () {
        function r(e) {
          var t,
            r,
            i = e.getAttribute(y.srcsetAttr);
          i &&
            (r = i.match(a)) &&
            ((t = "w" == r[2] ? r[1] / r[3] : r[3] / r[1]) &&
              e.setAttribute("data-aspectratio", t),
            e.setAttribute(y.srcsetAttr, i.replace(h, "")));
        }
        function e(e) {
          var t;
          e.detail.instance == p &&
            ((t = e.target.parentNode) &&
              "PICTURE" == t.nodeName &&
              s.call(t.getElementsByTagName("source"), r),
            r(e.target));
        }
        function t() {
          i.currentSrc && n.removeEventListener("lazybeforeunveil", e);
        }
        var i = n.createElement("img");
        n.addEventListener("lazybeforeunveil", e),
          (i.onload = t),
          (i.onerror = t),
          (i.srcset = "data:,a 1w 1h"),
          i.complete && t();
      });
  function v(e, t) {
    return e.w - t.w;
  }
  function w(e, t, r, i) {
    l.push({ c: t, u: r, w: +i });
  }
  function b(e, t) {
    var r,
      i = e.getAttribute("srcset") || e.getAttribute(y.srcsetAttr);
    !i &&
      t &&
      (i = e._lazypolyfill
        ? e._lazypolyfill._set
        : e.getAttribute(y.srcAttr) || e.getAttribute("src")),
      (e._lazypolyfill && e._lazypolyfill._set == i) ||
        ((r = o(i || "")),
        t &&
          e.parentNode &&
          ((r.isPicture = "PICTURE" == e.parentNode.nodeName.toUpperCase()),
          r.isPicture && d.matchMedia && (p.aC(e, "lazymatchmedia"), c())),
        (r._set = i),
        Object.defineProperty(e, "_lazypolyfill", { value: r, writable: !0 }));
  }
  function A(e) {
    var t,
      r,
      i,
      n,
      a,
      s,
      l,
      o,
      c,
      u = e;
    if ((b(u, !0), (n = u._lazypolyfill).isPicture))
      for (
        r = 0, i = (t = e.parentNode.getElementsByTagName("source")).length;
        r < i;
        r++
      )
        if (
          y.supportsType(t[r].getAttribute("type"), e) &&
          m(t[r].getAttribute("media"))
        ) {
          (u = t[r]), b(u), (n = u._lazypolyfill);
          break;
        }
    return (
      1 < n.length
        ? ((s = u.getAttribute("sizes") || ""),
          (s = (f.test(s) && parseInt(s, 10)) || p.gW(e, e.parentNode)),
          (n.d =
            ((l = e),
            (o = d.devicePixelRatio || 1),
            (c = p.getX && p.getX(l)),
            Math.min(c || o, 2.5, o))),
          !n.src || !n.w || n.w < s
            ? ((n.w = s),
              (a = (function (e) {
                for (var t, r, i = e.length, n = e[i - 1], a = 0; a < i; a++)
                  if ((((n = e[a]).d = n.w / e.w), n.d >= e.d)) {
                    !n.cached &&
                      (t = e[a - 1]) &&
                      t.d > e.d - 0.13 * Math.pow(e.d, 2.2) &&
                      ((r = Math.pow(t.d - 0.6, 1.6)),
                      t.cached && (t.d += 0.15 * r),
                      t.d + (n.d - e.d) * r > e.d && (n = t));
                    break;
                  }
                return n;
              })(n.sort(v))),
              (n.src = a))
            : (a = n.src))
        : (a = n[0]),
      a
    );
  }
  function E(e) {
    var t;
    (g && e.parentNode && "PICTURE" != e.parentNode.nodeName.toUpperCase()) ||
      ((t = A(e)) &&
        t.u &&
        e._lazypolyfill.cur != t.u &&
        ((e._lazypolyfill.cur = t.u),
        (t.cached = !0),
        e.setAttribute(y.srcAttr, t.u),
        e.setAttribute("src", t.u)));
  }
  y.supportsType ||
    (y.supportsType = function (e) {
      return !e;
    }),
    d.HTMLPictureElement && g
      ? !p.hasHDescriptorFix &&
        n.msElementsFromPoint &&
        ((p.hasHDescriptorFix = !0), z())
      : d.picturefill ||
        y.pf ||
        ((y.pf = function (e) {
          var t, r;
          if (!d.picturefill)
            for (t = 0, r = e.elements.length; t < r; t++) i(e.elements[t]);
        }),
        (f = /^\s*\d+\.*\d*px\s*$/),
        (t = /(([^,\s].[^\s]+)\s+(\d+)w)/g),
        (r = /\s/),
        (c = function () {
          var e, r;
          function t() {
            for (var e = 0, t = r.length; e < t; e++) i(r[e]);
          }
          c.init ||
            ((c.init = !0),
            addEventListener(
              "resize",
              ((r = n.getElementsByClassName("lazymatchmedia")),
              function () {
                clearTimeout(e), (e = setTimeout(t, 66));
              })
            ));
        }),
        (m = function (e) {
          return d.matchMedia
            ? (m = function (e) {
                return !e || (matchMedia(e) || {}).matches;
              })(e)
            : !e;
        }),
        (E.parse = o =
          function (e) {
            return (
              (l = []),
              (e = e.trim()).replace(h, "").replace(t, w),
              l.length || !e || r.test(e) || l.push({ c: e, u: e, w: 99 }),
              l
            );
          }),
        (i = E),
        y.loadedClass &&
          y.loadingClass &&
          ((u = []),
          ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(
            function (e) {
              u.push(e + y.loadedClass), u.push(e + y.loadingClass);
            }
          ),
          y.pf({ elements: n.querySelectorAll(u.join(", ")) })));
});
/*! optimumx */
!(function (e, t) {
  var n;
  e &&
    ((n = function () {
      t(e.lazySizes), e.removeEventListener("lazyunveilread", n, !0);
    }),
    (t = t.bind(null, e, e.document)),
    "object" == typeof module && module.exports
      ? t(require("lazysizes"))
      : "function" == typeof define && define.amd
      ? define(["lazysizes"], t)
      : e.lazySizes
      ? n()
      : e.addEventListener("lazyunveilread", n, !0));
})("undefined" != typeof window ? window : 0, function (t, e, s) {
  "use strict";
  var c, d, n, r, o, i, l, u, f, m, a;
  function p(e, t, n, i, r, a, d, u) {
    o.push({ c: t, u: n, w: +("w" == u ? d : i) });
  }
  function v(e, t) {
    return e.w - t.w;
  }
  function y(e, t) {
    var n = { srcset: e.getAttribute(s.cfg.srcsetAttr) || "" },
      i = r(n.srcset);
    return (
      Object.defineProperty(e, t, { value: n, writable: !0 }),
      (n.cands = i),
      (n.index = 0),
      (n.dirty = !1),
      i[0] && i[0].w
        ? (i.sort(v), (n.cSrcset = [i[n.index].c]))
        : ((n.cSrcset = n.srcset ? [n.srcset] : []), (n.cands = [])),
      n
    );
  }
  function g(e, t, n, i, r) {
    var a,
      d = e[r];
    d &&
      ((a = d.index),
      u[r](d, t, n),
      (d.dirty && a == d.index) ||
        (d.cSrcset.join(", "),
        e.setAttribute(i, d.cSrcset.join(", ")),
        (d.dirty = !0)));
  }
  t.addEventListener &&
    ((d = /^picture$/i),
    (n = e.documentElement),
    (i = /(([^,\s].[^\s]+)\s+(\d+)(w|h)(\s+(\d+)(w|h))?)/g),
    (r = function (e) {
      return (o = []), e.replace(i, p), o;
    }),
    (l = function (e, t) {
      var n, i, r, a;
      if (
        !e[t] &&
        ((a = e.parentNode || {}),
        (e[t] = y(e, t)),
        (e[t].isImg = !0),
        d.test(a.nodeName || ""))
      )
        for (
          e[t].picture = !0,
            i = 0,
            r = (n = a.getElementsByTagName("source")).length;
          i < r;
          i++
        )
          y(n[i], t).isImg = !1;
      return e[t];
    }),
    (u = {
      _lazyOptimumx: function (e, t, n) {
        for (var i, r, a, d, u, s, c = 0; c < e.cands.length; c++)
          if ((((i = e.cands[c]).d = (i.w || 1) / t), !(e.index >= c))) {
            if (
              !(i.d <= n) &&
              ((r = e.cands[c - 1]),
              (a = i.d),
              (d = n),
              (s = u = void 0),
              r &&
                r.d &&
                ((s = 0.7 < d ? 0.6 : 0.4),
                r.d >= d ||
                  ((u = Math.pow(r.d - s, 1.6) || 0.1) < 0.1
                    ? (u = 0.1)
                    : 3 < u && (u = 3),
                  !(r.d + (a - d) * u < d))))
            )
              break;
            e.cSrcset.push(i.c), (e.index = c);
          }
      },
    }),
    (f = function (e, t, n, i, r) {
      var a,
        d,
        u,
        s,
        c = e[r];
      if (((c.width = t), c.picture && (d = e.parentNode)))
        for (
          s = 0, u = (a = d.getElementsByTagName("source")).length;
          s < u;
          s++
        )
          g(a[s], t, n, i, r);
      g(e, t, n, i, r);
    }),
    (m = function (e) {
      var t = e.getAttribute("data-optimumx") || e.getAttribute("data-maxdpr");
      return (
        !t && c.constrainPixelDensity && (t = "auto"),
        (t = t && ("auto" == t ? c.getOptimumX(e) : parseFloat(t, 10)))
      );
    }),
    (a = function () {
      s &&
        !s.getOptimumX &&
        ((s.getX = m),
        (s.pWS = r),
        n.removeEventListener("lazybeforeunveil", a));
    }),
    n.addEventListener("lazybeforeunveil", a),
    setTimeout(a),
    "function" != typeof (c = s && s.cfg).getOptimumX &&
      (c.getOptimumX = function () {
        var e = t.devicePixelRatio || 1;
        return (
          2.6 < e ? (e *= 0.6) : 1.9 < e ? (e *= 0.8) : (e -= 0.01),
          Math.min(Math.round(100 * e) / 100, 2)
        );
      }),
    t.devicePixelRatio &&
      addEventListener("lazybeforesizes", function (e) {
        var t, n, i, r, a, d, u;
        e.detail.instance == s &&
          ((a = e.target),
          (u = (d = e.detail).dataAttr),
          e.defaultPrevented ||
            !(t = m(a)) ||
            t >= devicePixelRatio ||
            (!u ||
              !a._lazyOptimumx ||
              d.reloaded ||
              (c.unloadedClass && s.hC(a, c.unloadedClass)) ||
              (a._lazyOptimumx = null),
            (n = l(a, "_lazyOptimumx")),
            (i = d.width) &&
              (n.width || 0) < i &&
              ((r = u ? s.cfg.srcsetAttr : "srcset"),
              s.rAF(function () {
                f(a, i, t, r, "_lazyOptimumx");
              }))));
      }));
});
